import React from 'react';
import { LayerWrapper } from './LayerWrapper';
import type { LowerThirdLayer as LowerThirdLayerConfig, TemplateFontStyle } from '../../types';

interface LowerThirdLayerProps {
  layer: LowerThirdLayerConfig;
  reporterName: string;
  location: string;
  date: string;
}

export function LowerThirdLayer({
  layer,
  reporterName,
  location,
  date,
}: LowerThirdLayerProps) {
  const {
    position,
    animation,
    opacity,
    backgroundColor,
    accentColor,
    reporterNameFont,
    locationFont,
    dateFont,
  } = layer;

  const hasContent = reporterName || location || date;
  if (!hasContent) return null;

  return (
    <LayerWrapper position={position} animation={animation} opacity={opacity}>
      <div
        style={{
          width: '100%',
          height: '100%',
          backgroundColor,
          display: 'flex',
          alignItems: 'center',
          overflow: 'hidden',
        }}
      >
        {/* Accent bar */}
        <div
          style={{
            width: 6,
            height: '70%',
            backgroundColor: accentColor,
            flexShrink: 0,
            marginLeft: 16,
            marginRight: 14,
            borderRadius: 2,
          }}
        />

        {/* Text block */}
        <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', gap: 2 }}>
          {reporterName && (
            <span style={fontToStyle(reporterNameFont)}>{reporterName}</span>
          )}
          <div style={{ display: 'flex', gap: 12, alignItems: 'center' }}>
            {location && (
              <span style={fontToStyle(locationFont)}>{location}</span>
            )}
            {location && date && (
              <span style={{ ...fontToStyle(dateFont), opacity: 0.6 }}>·</span>
            )}
            {date && (
              <span style={fontToStyle(dateFont)}>{date}</span>
            )}
          </div>
        </div>
      </div>
    </LayerWrapper>
  );
}

function fontToStyle(font: TemplateFontStyle): React.CSSProperties {
  return {
    fontFamily: font.fontFamily,
    fontSize: font.fontSize,
    fontWeight: font.fontWeight,
    color: font.color,
    letterSpacing: font.letterSpacing,
    lineHeight: font.lineHeight,
    textTransform: font.textTransform,
    whiteSpace: 'nowrap',
  };
}
